module.exports = __webpack_public_path__ + "static/media/icon-sort-active.6d14e81a.svg";